import { CustomRoutes, localStorageStore, Admin as ReactAdmin } from 'react-admin'
import { BrowserRouter, Route } from 'react-router-dom'
import Layout from '../layout/Layout'
import { theme } from '../layout/themes'
import CostExplorer from '../pages/CostExplorer'
import Dashboard from '../pages/Dashboard'
import LoginPage from '../pages/Login'
import PortalSettingsPage from './OrgPortalBranding/OrgPortalBrandingTab'
import NoPermissions from '../pages/NoPermissions'
import Settings from '../pages/Settings'
import Unauthorized from '../pages/Unauthorized'
import WorkflowEditor from './Workflow/WorkflowEditor'
import providers from '../providers'
import { Permissions } from '../types/apiTypes'
import { resourcesForScopes } from './Resources'

const store = localStorageStore()
// Reuse the same authProvider instance across renders.
const authProvider = providers.auth()

const Admin = (): JSX.Element => (
  <BrowserRouter>
    <ReactAdmin
      i18nProvider={providers.i18n}
      authProvider={authProvider}
      dataProvider={providers.data}
      dashboard={Dashboard}
      layout={Layout}
      loginPage={LoginPage}
      disableTelemetry
      theme={theme}
      store={store}
    >
      { (permissions: Permissions): JSX.Element[] => resourcesForScopes(permissions) }
      <CustomRoutes>
        <Route path="/workflow/:id/editor" element={<WorkflowEditor />} />
        <Route path="/cost-explorer" element={<CostExplorer />} />
        <Route path="/portal-settings" element={<PortalSettingsPage />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/no-permissions" element={<NoPermissions />} />
      </CustomRoutes>
    </ReactAdmin>
  </BrowserRouter>
)

export default Admin
